import React from 'react';
import 'antd/dist/antd.css';
import { Col, Modal, Row, Form, Input, Checkbox, Divider, Tag, Button, Alert, Empty } from 'antd';
import "./GroupingModal.css";
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import * as actions from '../../../../store/actions/indexes'
// import { setHotelGroupList } from '../../../../store/actions/compHotelDropDownActions';
import { connect } from 'react-redux';
import _ from 'lodash';
import CommonConfig from '../../../commonConfig.json';

const { Search } = Input;

const REACT_APP_HMG = process.env["REACT_APP_HMG"];
const ENVS = CommonConfig.envs;

class GroupingModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tagMinHeight: 0,
            allUserItems: [],
            allCheckBoxOptions: [],
            searchedCheckBoxOptions: [],
            selectedGroupItems: [],
            selectedSearchedGroupItems: [],
            isAllGroupItemsSelected: false,
            isAllSearchedGroupItemsSelected: false,
            allGroups: [], //username, projectId, entityId, groupId, groupName, hotelList(env,id)
            currentUsername: '',
            currentUserGroupId: '',
            currentProjectId: '',
            currentEntityId: '',
            currentGroupId: '',
            currentGroupName: '',
            currentGroupNameValidation: {
                error: false,
                message: ''
            },
            pendingSubmit: false,
            submitRes: {
                alertVisible: false,
                alertType: '',
                alertMessage: ''
            },
            searchVal: ''
        };

        this.checkboxGrpRef = React.createRef();

        this.sortHotels = this.sortHotels.bind(this);
        this.camelCaseConvert = this.camelCaseConvert.bind(this);
        this.handleModalCancel = this.handleModalCancel.bind(this);
    }

    flag = true;

    /**
     * Sort the hotels in ascending order based on the environment
     * @param {*} arr 
     * @returns 
     */
    sortHotels = (arr) => {
        let arrcopy = [...arr];
        // for (const itm of arr) {
        //     arrcopy.push(JSON.parse(itm));
        // }
        return _.sortBy(arrcopy, [(a) => {
            if (REACT_APP_HMG === ENVS.GENERIC) {
                return (JSON.parse(a).name.toLowerCase())
            } else {
                return (JSON.parse(a).code.toLowerCase())
            }
        }]);
        // return arrcopy;
    }


    /**
     * Convert strings to Camel Case
     * @param {string} str 
     * @returns 
     */
    camelCaseConvert = (str) => {
        return _.replace(
            _.replace(str, /(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                return index == 0 ? word.toUpperCase() : word.toLowerCase();
            }),
            /\s+/g,
            '');
    }

    /**
     * search hotels
     * @param {string} str 
     * @returns 
     */
    searchGroupHotels = (str) => {

        var searchedValue = str.target.value;
        let filteredCheckboxGroup = [];
        let filteredTags = [];

        if (searchedValue) {
            if (this.state.allCheckBoxOptions.length != 0) { //checkbox section
                filteredCheckboxGroup = _.filter(this.state.allCheckBoxOptions, (ele) => {
                    return _.includes(ele.label.toLowerCase(), searchedValue.toLowerCase())
                });
            }

            if (this.state.selectedGroupItems.length != 0) { //tag section
                filteredTags = _.filter(this.state.selectedGroupItems, (ele) => {
                    let conEle = JSON.parse(ele);
                    return _.includes(conEle.label.toLowerCase(), searchedValue.toLowerCase());
                });
            }

            this.setState({
                searchVal: searchedValue,
                searchedCheckBoxOptions: filteredCheckboxGroup,
                selectedSearchedGroupItems: filteredTags.length != 0 ? this.sortHotels(filteredTags) : filteredTags,
                isAllSearchedGroupItemsSelected: filteredCheckboxGroup.length != 0 ? (filteredCheckboxGroup.length == filteredTags.length ? true : false) : false
            }, () => {
                if (this.checkboxGrpRef.current != null) {
                    let checkGroupHeight = this.checkboxGrpRef.current.clientHeight;
                    this.setState({ tagMinHeight: parseFloat(checkGroupHeight) + 20 })
                }
            });
        } else {
            this.setState({
                searchVal: searchedValue,
                searchedCheckBoxOptions: filteredCheckboxGroup,
                selectedSearchedGroupItems: filteredTags.length != 0 ? this.sortHotels(filteredTags) : filteredTags,
                isAllSearchedGroupItemsSelected: false
            }, () => {
                if (this.checkboxGrpRef.current != null) {
                    let checkGroupHeight = this.checkboxGrpRef.current.clientHeight;
                    this.setState({ tagMinHeight: parseFloat(checkGroupHeight) + 20 })
                }
            });
        }
    }

    /**
     * close Modal
     */
    handleModalCancel = () => {
        this.props.toggleGroupModalVisibility();
        this.setState({
            selectedGroupItems: [],
            isAllGroupItemsSelected: false,
            currentUsername: '',
            currentUserGroupId: '',
            currentProjectId: '',
            currentEntityId: '',
            currentGroupId: '',
            currentGroupName: '',
            currentGroupNameValidation: {
                error: false,
                message: ''
            },
            pendingSubmit: false,
            submitRes: {
                alertVisible: false,
                alertType: '',
                alertMessage: ''
            },
            isAllSearchedGroupItemsSelected: false,
            searchedCheckBoxOptions: [],
            selectedSearchedGroupItems: [],
            searchVal: ''
        })
    }

    /**
     * On change of Select All checkBox
     * @param {*} e 
     */
    onAllSelectChange = (e) => {
        this.setState(prevState => {
            let checkboxSelectedItems = [];
            let searchedCheckboxItems = [];
            if (this.state.searchVal) {
                let allCheckBoxItems = _.map(this.state.allCheckBoxOptions, (s) => s.value);
                searchedCheckboxItems = _.map(this.state.searchedCheckBoxOptions, (s) => s.value);

                if (!prevState.isAllSearchedGroupItemsSelected) { //if previously 'selectAll' not selected , now selected
                    let selectedNonExistItems = _.filter(searchedCheckboxItems, (ele) => { // select all items under a search compared with primary selected hotels array to extract non existing items in primary selected hotels array
                        return !_.includes(prevState.selectedGroupItems, ele);
                    });

                    checkboxSelectedItems = _.concat(prevState.selectedGroupItems, selectedNonExistItems);

                    return ({
                        isAllSearchedGroupItemsSelected: !prevState.isAllSearchedGroupItemsSelected,
                        isAllGroupItemsSelected: _.every(allCheckBoxItems, itm => checkboxSelectedItems.includes(itm)) ? true : false, //if all primary checkbox items available in search selected array => true
                        selectedGroupItems: checkboxSelectedItems.length != 0 ? this.sortHotels(checkboxSelectedItems) : checkboxSelectedItems,
                        selectedSearchedGroupItems: searchedCheckboxItems.length != 0 ? this.sortHotels(searchedCheckboxItems) : searchedCheckboxItems
                    })
                } else { //if previously 'selectAll' selected , now 
                    let unselectedItems = _.filter(prevState.selectedGroupItems, (ele) => { // final array items that removed searched unselected items from primary selected hotes array
                        return !_.includes(searchedCheckboxItems, ele);
                    });

                    return ({
                        isAllSearchedGroupItemsSelected: !prevState.isAllSearchedGroupItemsSelected,
                        isAllGroupItemsSelected: false,
                        selectedSearchedGroupItems: checkboxSelectedItems.length != 0 ? this.sortHotels(checkboxSelectedItems) : checkboxSelectedItems,
                        selectedGroupItems: unselectedItems.length != 0 ? this.sortHotels(unselectedItems) : unselectedItems
                    })
                }
            } else {
                if (!prevState.isAllGroupItemsSelected) { //if previously 'selectAll' not selected , now selected
                    checkboxSelectedItems = _.map(this.state.allCheckBoxOptions, (s) => s.value);
                    return ({
                        isAllGroupItemsSelected: !prevState.isAllGroupItemsSelected,
                        selectedGroupItems: checkboxSelectedItems.length != 0 ? this.sortHotels(checkboxSelectedItems) : checkboxSelectedItems,
                    })
                } else { //if previously 'selectAll' selected , now unselect
                    return ({
                        isAllGroupItemsSelected: !prevState.isAllGroupItemsSelected,
                        selectedGroupItems: checkboxSelectedItems.length != 0 ? this.sortHotels(checkboxSelectedItems) : checkboxSelectedItems,
                    })
                }
            }
        })
    }

    /**
     * On change of single checkbox item
     * @param {*} checkedVal 
     */
    checkBoxOnChange = (checkedVal) => {
        this.setState(prevState => {
            if (this.state.searchVal) {
                let searchedCheckboxItems = [];
                let selectedGroupItems = [];
                searchedCheckboxItems = _.map(prevState.searchedCheckBoxOptions, (s) => s.value);

                let selectedExcludedSearchHotels = _.filter(prevState.selectedGroupItems, (ele) => { //selected items of main array that excludes searched items
                    return !_.includes(searchedCheckboxItems, ele);
                });
                selectedGroupItems = _.concat(selectedExcludedSearchHotels, checkedVal);
                return ({
                    "selectedSearchedGroupItems": checkedVal.length != 0 ? this.sortHotels(checkedVal) : checkedVal,
                    "isAllSearchedGroupItemsSelected": (this.state.searchedCheckBoxOptions.length != 0 && checkedVal.length == this.state.searchedCheckBoxOptions.length ? true : false),
                    "selectedGroupItems": selectedGroupItems.length != 0 ? this.sortHotels(selectedGroupItems) : selectedGroupItems,
                    "isAllGroupItemsSelected": (this.state.allCheckBoxOptions.length != 0 && selectedGroupItems.length == this.state.allCheckBoxOptions.length ? true : false)
                })
            } else {
                return ({
                    "selectedGroupItems": checkedVal.length != 0 ? this.sortHotels(checkedVal) : checkedVal,
                    "isAllGroupItemsSelected": (this.state.allCheckBoxOptions.length != 0 && checkedVal.length == this.state.allCheckBoxOptions.length ? true : false)
                })
            }
        });

    }

    /**
     * On click of Clear All button at Hotels in Groups section
     * @param {*} e 
     */
    onClearAllClick = (e) => {
        this.setState(prevState => {
            if (this.state.searchVal) {
                let searchedCheckboxItems = _.map(this.state.searchedCheckBoxOptions, (s) => s.value);

                let unselectedItems = _.filter(prevState.selectedGroupItems, (ele) => { //final array items that removed searched cleared items from primary selected hotes array
                    return !_.includes(searchedCheckboxItems, ele);
                });

                return ({
                    isAllSearchedGroupItemsSelected: false,
                    isAllGroupItemsSelected: false,
                    selectedSearchedGroupItems: [],
                    selectedGroupItems: unselectedItems.length != 0 ? this.sortHotels(unselectedItems) : unselectedItems
                })
            } else {
                return ({
                    isAllGroupItemsSelected: false,
                    selectedGroupItems: [],
                })
            }
        });

    }

    /**
     * On click of close icon on the hotel tags
     * @param {*} e event
     * @param {*} i index
     */
    onHotelTagClose = (e, i) => {
        e.preventDefault();
        let selectedGroupItems = [];
        let selectedSearchedGroupItems = [];
        if (this.state.searchVal) {
            let selectedGroupItems = _.filter(this.state.selectedGroupItems, (item) => item !== i);
            let selectedSearchedGroupItems = _.filter(this.state.selectedSearchedGroupItems, (item) => item !== i);
            this.setState({
                'selectedGroupItems': selectedGroupItems.length != 0 ? this.sortHotels(selectedGroupItems) : selectedGroupItems,
                'selectedSearchedGroupItems': selectedSearchedGroupItems.length != 0 ? this.sortHotels(selectedSearchedGroupItems) : selectedSearchedGroupItems,
                'isAllGroupItemsSelected': false,
                'isAllSearchedGroupItemsSelected': false
            })
        } else {
            let selectedGroupItems = _.filter(this.state.selectedGroupItems, (item) => item !== i);
            this.setState({
                'selectedGroupItems': selectedGroupItems.length != 0 ? this.sortHotels(selectedGroupItems) : selectedGroupItems,
                'isAllGroupItemsSelected': false
            })
        }

    }

    /**
     * On submit of modal form
     * @param {*} e 
     */
    onSubmit = async (e) => {
        this.setState({ pendingSubmit: true }, async () => {
            let processedItemList = [];
            for (let index = 0; index < e['hotel-checkbox-group'].length; index++) {
                const element = JSON.parse(e['hotel-checkbox-group'][index]);
                console.log('hotel-checkbox-group', element);
                processedItemList.push({ "env": element.env, "id": element.id });
            }
            if (this.props.data.action !== undefined && this.props.data.action == "CREATE") {

                let createCallData = {
                    "userName": this.state.currentUsername,
                    "groupName": e['groupname'],
                    "projectId": this.state.currentProjectId,
                    "entityId": this.state.currentEntityId,
                    "hotelList": processedItemList
                }
                await this.props.createGroup(createCallData);
                if (this.props.submissionResponse.submissionType == 'CREATE') {
                    if (this.props.submissionResponse.responseType == 'SUCCESS') {
                        this.setState({
                            submitRes: {
                                alertVisible: true,
                                alertType: 'success',
                                alertMessage: this.props.submissionResponse.responseData.message
                            },
                            pendingSubmit: false
                        }, () => {
                            let processedItemListResponse = [];
                            if (this.props.submissionResponse.responseData.data.length != 0) {
                                // processedHotelListResponse = this.processHotelGroupResponse(this.props.submissionResponse.responseData.data);
                                processedItemListResponse = this.props.submissionResponse.responseData.data;
                            }
                            // this.props.setHotelGroupList(processedHotelListResponse) 
                            //TODO: callback of updating new group in currentProj 
                            this.props.submitCallback.callback(
                                this.props.data.index.indexName, 
                                this.props.data.index.indexValueType, 
                                "groupedData",
                                processedItemListResponse, 
                                [],
                                "CREATE"
                            )
                            // console.log(this.props.hotelGroupList, "hotelGroupList Saved")
                            setTimeout(() => {
                                this.handleModalCancel();
                            }, 3000)
                        })
                    } else if (this.props.submissionResponse.responseType == 'FAIL') {
                        this.setState({
                            submitRes: {
                                alertVisible: true,
                                alertType: 'error',
                                alertMessage: this.props.submissionResponse.responseData.message
                            },
                            pendingSubmit: false
                        }, () => {
                            setTimeout(() => {
                                this.handleModalCancel();
                            }, 3000)
                        })
                    }
                }

            } else if (this.props.data.action !== undefined && this.props.data.action == "EDIT") {
                //include the disabled===true items to the processedItemList
                let disabledItemList = this.props.data.currentGroupData.mappedList
                .filter(l => l.isDisable === true)
                .map(m => {
                    delete m.isDisable
                    return m
                });
                processedItemList = processedItemList.concat(disabledItemList);
                let editCallData = {
                    "userGroupId": this.state.currentUserGroupId,
                    "groupId": this.state.currentGroupId,
                    "userName": this.state.currentUsername,
                    "groupName": e['groupname'],
                    "projectId": this.state.currentProjectId,
                    "entityId": this.state.currentEntityId,
                    "hotelList": processedItemList
                }
                await this.props.editGroup(editCallData);
                if (this.props.submissionResponse.submissionType == 'EDIT') {
                    if (this.props.submissionResponse.responseType == 'SUCCESS') {
                        this.setState({
                            submitRes: {
                                alertVisible: true,
                                alertType: 'success',
                                alertMessage: this.props.submissionResponse.responseData.message
                            },
                            pendingSubmit: false
                        }, () => {
                            let processedItemListResponse = [];
                            if (this.props.submissionResponse.responseData.data.length != 0) {
                                // processedHotelListResponse = this.processHotelGroupResponse(this.props.submissionResponse.responseData.data);
                                processedItemListResponse = this.props.submissionResponse.responseData.data;
                            }
                            // this.props.setHotelGroupList(processedHotelListResponse)
                            //TODO: callback of updating new group in currentProj 
                            this.props.submitCallback.callback(this.props.data.index.indexName,
                                this.props.data.index.indexValueType, 
                                "groupedData",
                                processedItemListResponse, 
                                [{userGroupId: this.state.currentUserGroupId, groupId: this.state.currentGroupId}],
                                "EDIT"
                            )
                            setTimeout(() => {
                                // console.log(this.props.hotelGroupList, "hotelGroupList Saved")
                                this.handleModalCancel();
                            }, 3000)
                        })
                    } else if (this.props.submissionResponse.responseType == 'FAIL') {
                        this.setState({
                            submitRes: {
                                alertVisible: true,
                                alertType: 'error',
                                alertMessage: this.props.submissionResponse.responseData.message
                            },
                            pendingSubmit: false
                        }, () => {
                            setTimeout(() => {
                                this.handleModalCancel();
                            }, 3000)
                        })
                    }
                }
            }
        });
    }

    /**
     * on blur of group name field
     * @param {*} e 
     */
    onGroupNameInput = (e) => {
        e.preventDefault();
        let enteredHotelGroupName = e.target.value;
        if (enteredHotelGroupName != "" && enteredHotelGroupName !== null) {
            if (this.props.data.action == "CREATE") { // check groupname on all groups
                if (this.state.allGroups.length != 0) {
                    if (_.find(this.state.allGroups, (item) => item.groupName.trim().toLowerCase() == enteredHotelGroupName.trim().toLowerCase()) !== undefined) {
                        // if same group name available, throw error
                        // console.error('same group name availble');
                        this.setState({
                            currentGroupName: '',
                            currentGroupNameValidation: {
                                error: true,
                                message: 'Entered group name already exists. Please enter different group name'
                            }
                        })
                    } else { // if no same group name, set the state
                        this.setState({
                            currentGroupName: enteredHotelGroupName,
                            currentGroupNameValidation: {
                                error: false,
                                message: ''
                            }

                        })
                    }
                } else {
                    this.setState({
                        currentGroupName: enteredHotelGroupName,
                        currentGroupNameValidation: {
                            error: false,
                            message: ''
                        }

                    })
                }
            } else if (this.props.data.action == "EDIT") { // check groupname on other groups other than current
                if (this.state.allGroups.length != 0) {
                    if (_.find(this.state.allGroups, (item) => item.groupId != this.state.currentGroupId && item.groupName.trim().toLowerCase() == enteredHotelGroupName.trim().toLowerCase()) !== undefined) {
                        // if same group name available, throw error
                        // console.error('same group name availble');
                        this.setState({
                            currentGroupName: '',
                            currentGroupNameValidation: {
                                error: true,
                                message: 'Entered group name already exists. Please enter different group name'
                            }
                        })
                    } else {
                        this.setState({
                            currentGroupName: enteredHotelGroupName,
                            currentGroupNameValidation: {
                                error: false,
                                message: ''
                            }

                        })
                    }
                } else {
                    // throw error, something wrong when passing group data to modal
                    console.error('something wrong when passing group data to modal');
                }
            }
        } else {
            this.setState({
                currentGroupName: '',
                currentGroupNameValidation: {
                    error: true,
                    message: 'Please enter the group name'
                }

            })
        }

        // console.log(e.target.value);

    }

    componentDidMount(prevProps, prevState) {
        if ((this.props.visible && this.state.allCheckBoxOptions.length == 0) || prevProps.data.allGroupData != this.props.data.allGroupData) {
            // console.log(this.props.hotelGroupList, "hotelGroupList...")
            let allOptions = [];
            for (const userHotel of this.props.data.mappingList) {
                allOptions.push(
                    {
                        label: userHotel.label,
                        value: JSON.stringify(userHotel)
                    }
                )
            }

            this.setState({
                "allUserItems": this.props.data.mappingList,
                "allCheckBoxOptions": allOptions,
                "allGroups": this.props.data.allGroupData
            })
        }

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.visible && this.state.allCheckBoxOptions.length > 0) {
            // Setting current loaded entityId,projectId,username
            if (this.props.data.action !== undefined && this.props.data.action === "CREATE" && this.state.currentProjectId === '' && this.state.currentEntityId === '' && this.state.currentUsername === '') {
                this.setState({
                    currentUsername: this.props.data.userName,
                    currentProjectId: this.props.data.projectId,
                    currentEntityId: this.props.data.entityId,
                })
            }
            // Setting Hotel Group Data for the selected at initial load
            if (this.props.data.action !== undefined && this.props.data.action === "EDIT" && this.state.currentUserGroupId === '') {
                if (!_.isEmpty(this.props.data.currentGroupData) && this.props.data.currentGroupData.groupId !== undefined) {
                    let selectedItems = [];
                    for (let index = 0; index < this.props.data.currentGroupData.mappedList.length; index++) {
                        const mappedItem = this.props.data.currentGroupData.mappedList[index];
                        let foundItem = _.find(this.state.allUserItems, (s) => s.env === mappedItem.env && s.id === mappedItem.id && mappedItem.isDisable === false);
                        if (foundItem !== undefined) {
                            selectedItems.push(JSON.stringify(foundItem));
                        }
                    }
                    this.setState({
                        currentUsername:  this.props.data.currentGroupData.userName,
                        currentUserGroupId:  this.props.data.currentGroupData.userGroupId,
                        currentProjectId:  this.props.data.currentGroupData.projectId,
                        currentEntityId:  this.props.data.currentGroupData.entityId,
                        currentGroupId:  this.props.data.currentGroupData.groupId,
                        currentGroupName:  this.props.data.currentGroupData.groupName,
                        selectedGroupItems: selectedItems,
                        isAllGroupItemsSelected: selectedItems.length === this.state.allUserItems.length ? true : false
                    })
                } else {
                    console.error('Passed group not available on list');
                }
            }

            // Tag section set minheight on render of checkbox section
            if (this.flag) {
                this.flag = false;
                // if(window.innerWidth >= 768){
                // console.log('window width', window.innerWidth);

                setTimeout(() => {
                    if (this.checkboxGrpRef.current != null) {
                        let checkGroupHeight = this.checkboxGrpRef.current.clientHeight;
                        this.setState({ tagMinHeight: parseFloat(checkGroupHeight) + 20 })
                    }
                }, 1);
                // }
            }
        }
    }

    render() {
        if (this.props.visible) {

            return (
                <Modal
                    // title="Title"
                    centered
                    visible={this.props.visible}
                    // onOk={handleOk}
                    // confirmLoading={confirmLoading}
                    okText={this.props.submitCallback.label}
                    cancelText={this.props.closeCallback.label}
                    okButtonProps={{
                        form: 'hotel-group-editor-form',
                        key: 'submit',
                        htmlType: 'submit',
                        loading: this.state.pendingSubmit,
                        disabled: (this.state.selectedGroupItems.length != 0 && this.state.currentGroupName != '' && !this.state.currentGroupNameValidation.error) ? false : true
                    }}
                    cancelButtonProps={{
                        disabled: this.state.pendingSubmit,
                        type: this.props.closeCallback.type
                    }}
                    onCancel={this.handleModalCancel}
                    className="hotelGroupingModal"
                    // width={1024}
                    destroyOnClose={true}
                    maskClosable={false}
                    closable={false}
                    keyboard={false}
                >
                    <Form
                        // form={form}
                        // validateMessages={}
                        id="hotel-group-editor-form"
                        layout="vertical"
                        requiredMark={false}
                        onFinish={this.onSubmit}
                        // initialValues={{
                        //     ["groupname"]:this.state.currentGroupName
                        // }}
                        fields={[
                            {
                                name: ["groupname"],
                                value: this.state.currentGroupName,
                            },
                            {
                                name: ["hotel-checkbox-group"],
                                value: this.state.selectedGroupItems,
                            },
                            {
                                name: ["grouphotel-selected-tags"],
                                value: this.state.selectedGroupItems,
                            },
                        ]}
                    // initialValues={{
                    //     requiredMarkValue: requiredMark,
                    // }}
                    // onValuesChange={onRequiredTypeChange}
                    // requiredMark={requiredMark}
                    >
                        <Row className="groupModalTopSec">
                            <Col xs={24} sm={24} md={10} lg={10} xl={10} xxl={10} className="groupActionTitle">
                                <span>{`${this.camelCaseConvert(this.props.data.action)} ${this.props.data.index.indexName} Group`}</span>
                            </Col>
                            <Col xs={24} sm={24} md={14} lg={14} xl={14} xxl={14}>
                                <Form.Item
                                    name="groupname"
                                    className="groupNameInput"
                                    label="Group Name"
                                    validateStatus={this.state.currentGroupNameValidation.error ? "error" : ""}
                                    validateTrigger='onBlur'
                                    help={this.state.currentGroupNameValidation.message}
                                    // rules={[
                                    //     {
                                    //         required: true,
                                    //         message: 'Please enter the group name',
                                    //     },
                                    // ]}
                                    tooltip="Group name is required"
                                >
                                    <Input
                                        placeholder="Enter Hotel Group Name"
                                        // allowClear={true}
                                        // defaultValue={this.state.currentGroupName}
                                        // value={this.state.currentGroupName}
                                        maxLength={70}
                                        disabled={this.state.pendingSubmit}
                                        bordered={false}
                                        onBlur={this.onGroupNameInput} />
                                </Form.Item>
                            </Col>
                        </Row>
                        {this.state.submitRes.alertVisible ? (
                            <Row>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                    <Alert
                                        message={this.state.submitRes.alertMessage}
                                        type={this.state.submitRes.alertType}
                                        // message="success data save"
                                        // type="success"
                                        showIcon
                                    />
                                </Col>
                            </Row>
                        ) : ("")}
                        <Row className="groupModalSearchSec">
                            <Col xs={24} sm={24} md={10} lg={10} xl={10} xxl={10}>
                                <Search
                                    allowClear
                                    prefix={<SearchOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />}
                                    placeholder="Search"
                                    // onSearch={value => console.log(value)}
                                    value={this.state.searchVal}
                                    onChange={this.searchGroupHotels}
                                    style={{ borderRadius: '4px', borderColor: '#cad3da' }}
                                // onKeyDown={this.keyDown}
                                />
                            </Col>
                        </Row>
                        <Row className="groupModalMidSec">
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                                <Form.Item
                                    name="hotel-checkbox-group"
                                    label="Select Hotels"
                                    className="groupHotelsCheckBoxes"
                                    validateStatus={this.state.selectedGroupItems == 0 ? "error" : ""}
                                    validateTrigger='onBlur'
                                    help={this.state.searchVal ?
                                        (this.state.searchedCheckBoxOptions.length == 0 ? ''
                                            : (this.state.selectedGroupItems == 0 ? 'Please select hotels for the group' : ''))
                                        : (this.state.selectedGroupItems == 0 ? 'Please select hotels for the group' : '')}
                                >
                                    <Divider />
                                    <div className="hotel-checkbox-group"
                                        ref={this.checkboxGrpRef}
                                        style={this.state.searchVal ?
                                            (this.state.searchedCheckBoxOptions.length == 0 ? { "minHeight": "20px" } : {}) : (this.state.allCheckBoxOptions.length == 0 ? { "minHeight": "20px" } : {})}
                                    >
                                        <Checkbox
                                            disabled={this.state.pendingSubmit}
                                            onChange={this.onAllSelectChange}
                                            checked={this.state.searchVal ? this.state.isAllSearchedGroupItemsSelected : this.state.isAllGroupItemsSelected}
                                            style={this.state.searchVal ? (this.state.searchedCheckBoxOptions.length > 1 ? { "display": "block" } : { "display": "none" }) : (this.state.allCheckBoxOptions.length > 1 ? { "display": "block" } : { "display": "none" })}
                                        >
                                            Select All
                                        </Checkbox>
                                        <Checkbox.Group
                                            options={this.state.searchVal ? this.state.searchedCheckBoxOptions : this.state.allCheckBoxOptions}
                                            value={this.state.selectedGroupItems}
                                            onChange={this.checkBoxOnChange}
                                            disabled={this.state.pendingSubmit}
                                            style={this.state.searchVal ? (this.state.searchedCheckBoxOptions.length > 0 ? { "display": "block" } : { "display": "none" }) : (this.state.allCheckBoxOptions.length > 0 ? { "display": "block" } : { "display": "none" })}
                                        ></Checkbox.Group>
                                    </div>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                                <Form.Item
                                    name="grouphotel-selected-tags"
                                    className="groupHotelsSelectedTags"
                                    // name="hotel-tag-group"
                                    label="Hotels in Group"
                                >
                                    <Button type="link"
                                        className="groupHotelsSelectedClear"
                                        style={this.state.searchVal ? (this.state.selectedSearchedGroupItems.length > 1 ? { "display": "block" } : { "display": "none" }) : (this.state.selectedGroupItems.length > 1 ? { "display": "block" } : { "display": "none" })}
                                        icon={<CloseOutlined />}
                                        onClick={this.onClearAllClick}
                                        disabled={this.state.pendingSubmit}
                                    >Clear All
                                    </Button>
                                    <Divider />
                                    <div className="hotel-tag-group"
                                        style={
                                            // { "minHeight": this.state.tagMinHeight }}
                                            this.state.searchVal ? (this.state.searchedCheckBoxOptions.length == 0 ? { "minHeight": "20px" } : { "minHeight": this.state.tagMinHeight }) : (this.state.allCheckBoxOptions.length == 0 ? { "minHeight": "20px" } : { "minHeight": this.state.tagMinHeight })}
                                    >
                                        {
                                            (this.state.searchVal ?
                                                (this.state.selectedSearchedGroupItems.length != 0 ?
                                                    this.state.selectedSearchedGroupItems.map(hoteltag => {
                                                        return <Tag
                                                            closable={this.state.pendingSubmit ? false : true}
                                                            onClose={e => this.onHotelTagClose(e, hoteltag)}
                                                            key={hoteltag}
                                                        >
                                                            {JSON.parse(hoteltag).label}
                                                        </Tag>
                                                    })
                                                    : "")
                                                : (this.state.selectedGroupItems.length != 0 ?
                                                    this.state.selectedGroupItems.map(hoteltag => {
                                                        return <Tag
                                                            closable={this.state.pendingSubmit ? false : true}
                                                            onClose={e => this.onHotelTagClose(e, hoteltag)}
                                                            key={hoteltag}
                                                        >
                                                            {JSON.parse(hoteltag).label}
                                                        </Tag>
                                                    })
                                                    : "")
                                            )
                                        }
                                    </div>
                                </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} style={this.state.searchVal ? (this.state.searchedCheckBoxOptions.length == 0 ? { "display": "block" } : { "display": "none" }) : (this.state.allCheckBoxOptions.length == 0 ? { "display": "block" } : { "display": "none" })}>
                                <Empty
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    description='No search result found'
                                    style={{ 'margin': '0 0 32px 0' }}
                                />
                            </Col>
                        </Row>
                        <Divider className="dividerBeforeBottomSection" />
                    </Form>
                </Modal>
            )

        } else {
            return ("");
        }





    }
}

const mapStateToProps = (state) => {
    return {
        // modalVisible: state.groupingModalReducer.groupingModalOpen,
        // modalData: state.groupingModalReducer.groupingModalData,
        // hotelGroupList: state.complianceHotelDropDownReducer.hotelGroupList,
        submissionResponse: state.groupingModalReducer.submissionResponse
    }
}

const mapDispatchToProps = (dispatch) => ({
    toggleGroupModalVisibility: () => dispatch(actions.toggleGroupModalVisibility()),
    createGroup: (params) => dispatch(actions.createGroup(params)),
    editGroup: (params) => dispatch(actions.editGroup(params)),
    // setHotelGroupList: (params) => dispatch(setHotelGroupList(params))
})

export default connect(mapStateToProps, mapDispatchToProps)(GroupingModal);
